<template>
    <modal partners @close="$emit('close')">
        <div class="py-8  text-main-text relative">
            <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
                    <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
                </button>
            <div class="flex flex-col text-center w-full justify-center relative items-center pb-4">

                <div class="px-6 mt-10">
                    <img class="-mt-6 flex w-1/4 mb-6 mx-auto" src="../../../../assets/SVG/big-cross.svg"
                        alt="check-circle">
                    <p class="flex flex-col heading text-center w-full justify-center items-center font-extrabold">
                         Необходимо удалить эту команду <br> из другой игры данной серии</p>
                    <div
                        class="text-sm flex flex-col text-center w-full justify-center items-center pt-4">
                        <p>Команду нельзя перенести в основной список, <br> пока она зарегистрирована в этой серии</p>
                    </div>


                </div>
            </div>

        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'Error Modal',
  components: { Modal },
  props: ['success_or_fail', 'success'],
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
    };
  },

};

</script>

<style scoped>

.heading {
    font-size: 18px;
}
</style>
